module.exports = __webpack_public_path__ + "static/media/ok.34e80384.png";